import { useEffect } from "react";
import Banner from "../../Banner/Banner";
import "./Swap.css";
import translation from "../../Translations/translation.json";
import SeoJson from "../../SeoJson";
import { Helmet } from "react-helmet-async";
import { useLanguage } from "../../LanguageContext";

const Swap = () => {
  const { language } = useLanguage();

  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };
  const url = "https://powdex.io/swap";
  const title = `${translate("titleBar.swapTitle")}`;
  // "PoWDex — Seamless Swaps on ETHW";
  const desc =
    "Swap tokens on EthereumPoW (ETHW) with fast, non-custodial execution. Select a token, set Sell/Buy amounts, and get started on PoWDex.";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {" "}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} />
        <link rel="canonical" href={url} />

        {/* OG / Twitter */}
        <meta property="og:site_name" content="PoWDex" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={url} />
        <meta
          property="og:image"
          content="https://powdex.io/https://res.cloudinary.com/dbtsrjssc/image/upload/v1734153508/powdex_svg_165_ym6eui.svg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "WebApplication",
          name: "PoWDex Swap",
          url,
          operatingSystem: "Web",
          applicationCategory: "FinanceApplication",
          description: desc,
        }}
      />
      {/* HowTo schema: Swapping process */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "HowTo",
          name: "How to swap tokens on PoWDex",
          step: [
            {
              "@type": "HowToStep",
              name: "Connect wallet",
              text: "Open PoWDex Swap and connect MetaMask on EthereumPoW.",
            },
            {
              "@type": "HowToStep",
              name: "Select tokens",
              text: "Choose which token to swap from and which token to receive.",
            },
            {
              "@type": "HowToStep",
              name: "Enter amount",
              text: "Type the amount you want to swap. Review estimated output.",
            },
            {
              "@type": "HowToStep",
              name: "Confirm swap",
              text: "Click Swap and confirm the transaction in your wallet.",
            },
          ],
        }}
      />
      <main>
        <div className="section-bg-pages">
          <Banner />
        </div>
      </main>
    </>
  );
};

export default Swap;
